<template>
    <div>
            <top-navbar></top-navbar>
    
    
            <div class=" mb-5 background_color" >
              <h6 class="manage-boder pt-2 font1  decoration"> <router-link class="decoration" to="/"> Home </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><a class="decoration" > Product Sales </a><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span><router-link class="decoration" to="/mproduct/index"> Manage Product  </router-link><span class="pfimg3"><i class="fa fa-angle-right" aria-hidden="true"></i></span> {{ products.P_code }}  </h6>
                <!-- <h6 class="custom-maintitle mb-1"><b>{{ products.P_code }}  </b></h6> -->

                <div class="container-fluid" >


                <div class="d-grid gap-2 d-md-flex justify-content-md-end">
       

                  <button  @click="Update()"  class="btn btn-sm  btn-outline-primary mb-1 bdr-rad"> Update</button>
                 
            
                </div>

                <div class="card custom_bdr_rds shadow p-2" v-if="isLoading">
                  <div class="card-body custom_bdr_rds">

                <div class="d-flex justify-content-center" >
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>

                  </div>
                </div>

                <div v-else class="mt-1">
                  <div >



                <div class="card custom_bdr_rds shadow p-2">
                <div class="card-body custom_bdr_rds">


                    <table style="font-size: small; " class="table table-hover  table-sm table-borderless  ">
       
                        <tbody >
                 
                         
                          <tr>
                            <td class="width-custom2"><b>Product Code </b></td>
                           <td>{{ products.P_code }}</td> 
                          </tr>
                          <tr>
                            <td><b>Product Description</b></td>
                           <td>{{ products.P_description }}</td> 
                          </tr>
                         
                          <tr>
                            <td><b>Product Category</b></td>
                           <td>{{ category.PC_description }}</td> 
                          </tr>
                          <tr>
                            <td><b>Brand </b></td>
                           <td>{{ brand.brand_name }}</td> 
                          </tr>
                          <tr>
                            <td><b>BIN Location </b></td>
                           <td></td> 
                          </tr>
                          <tr>
                            <td><b>Supplier </b></td>
                           <td>{{ supplier.sup_name }}</td> 
                          </tr>
                          <tr>
                            <td><b>Price </b></td>
                           <td>{{ products.P_internal_selling_price }}</td> 
                          </tr>
                          <tr>
                            <td><b>Fuel Type </b></td>
                           <td></td> 
                          </tr>
                          <tr>
                            <td><b>Vehicle Category </b></td>
                           <td></td> 
                          </tr>
                          <tr>
                            <td><b>HS Code </b></td>
                           <td></td> 
                          </tr>
                          <tr>
                            <td><b>ROQ</b></td>
                           <td>{{ products.ROQ }}</td> 
                          </tr>
                          <tr>
                            <td><b>Status</b></td>
                           <td>{{ status.status }}</td> 
                          </tr>
                          <tr>
                            <td><b>Created Date</b></td>
                           <td>{{ products.P_created_date }}</td> 
                          </tr>
                          <tr>
                            <td><b>Created By</b></td>
                           <td>{{ user.username }}</td> 
                          </tr>
                         
                           
                        </tbody>
                 
                 
                      </table>

                </div>
                </div>



                    <div class="card custom_bdr_rds shadow p-2">
                        <div class="card-body custom_bdr_rds">
                            <h6 class="purchitem mb-2"><b>Audit Trail</b></h6>

                        <div class="table-responsive">
                            
                        <table style="font-size: small; " class="table table-hover table-sm table-borderless ">
                            <thead class="background_color2">
                              <tr class="custom-label2">
                              <th>#</th>
                              <th>Field Name</th>
                              <th>Comment</th>
                              <th>Action</th>
                              <th>Created Date</th>
                              <th>Created Time</th>
                              <th>Created By</th>
                              <th>Previous Value</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr  v-for="(contact, index) in contacts" :key="contact.id">
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              </tr>
                            </tbody>

                          </table>

                          </div>


                        </div>
                    </div>



   

<br><br>





                




                </div>
                </div>
           
            </div>
          </div>
    
            <!-- <vue-select label="value" style="z-index: 999;" v-model="selectedOption" :options="options" ></vue-select> <br><br><br><br><br><br> -->
            <content-footer></content-footer>
    </div>
    </template>
    <script>
   
     import axios from 'axios';
     import authService from '@/auth.service';
      import TopNavbar from './../../layout/TopNavbar.vue'
      import ContentFooter from './../../layout/ContentFooter.vue'
     
    
    
      export default {

        mounted(){
    this.loadMcutomer()
      },
        data() {
          return {
            access_token:authService.isLoggedIn(),
            userid:authService.isUserid(),
            'idproduct':this.$route.query.id,
            customers:{},
            products:{},
            category:{},
            brand:{},
            supplier:{},
            status:{},
            user:{},
            contacts:[],
            trans:[],
     
           
          }
    
        },
        components :{
         
            ContentFooter,
            TopNavbar,
           
        },

        methods : {

          
          async Update(){
        this.$router.push('/mproduct/update?id='+this.idproduct);
      },

            async loadMcutomer(id) {
        console.log("Amila");
      console.log(this.access_token);
      try {
        const { data} = await  axios.get('/mproduct/view?id='+this.idproduct,{
          headers:{
            'Authorization':'Bearer '+this.access_token,
            'Content-type': 'application/json',
           
          }
         });
         console.log(data);
         this.products = data.item_list
         this.category = data.category
         this.brand = data.brand
         this.supplier = data.supplier
         this.status = data.status
         this.user = data.user
        
      } catch (error) {
        console.log(error.response);
      }
    },

  

        

  

    },
    
    }
    
    </script>

    <style scoped>
      /* @import "vue-select/dist/vue-select.css"; */
/* .vs__dropdown-option--disabled {
    display: block;
} */

.button-link {
  display: inline-block;
  padding: 5px 10px;
  font-size: small;
  text-decoration: none;
  color: #3899ea;
 
 
  
  cursor: pointer;
}

.button-link:hover {
  color: black;
  text-decoration: underline;
}
    </style>